( function ( $ ) {
	if ( $( '.form-estim' ).length > 0 ) {
		$( '.form-estim__nav__item a' ).on( 'click', function ( event ) {
			event.preventDefault();
			event.stopPropagation();

			if ( ! $( this ).hasClass( 'disabled' ) ) {
				$( this ).closest( '.form-estim__nav' ).find( '.form-estim__nav__item' ).removeClass( 'active' );

				$( this ).parent().addClass( 'active' );
				const href = $( this ).attr( 'href' );

				$( this ).closest( '.form-estim' ).find( '.form-estim__box' ).fadeOut();
				$( href ).fadeIn();

				$( '.form-estim__bottom__links a' ).removeClass( 'active' );

				if ( $( '.form-estim__bottom__links a[data-box=' + href + ']' ).length > 0 ) {
					$( '.form-estim__bottom__links a[data-box=' + href + ']' ).addClass( 'active' );
					$( '.form-estim__bottom__txt' ).show();
					$( '.form-estim__buttons--estimate' ).css( 'text-align', '' );
				} else {
					$( '.form-estim__bottom__txt' ).hide();
					$( '.form-estim__buttons--estimate' ).css( 'text-align', 'center' );
				}
			}
		} );

		$( '.form-estim .btn--next' ).on( 'click', function ( event ) {
			event.preventDefault();
			event.stopPropagation();
			const href = $( this ).attr( 'href' );

			$( this )
				.closest( '.form-estim' )
				.find( '.form-estim__nav__item a[href=' + href + ']' )
				.trigger( 'click' );
		} );

		$( '.form-estim__bottom__links a' ).on( 'click', function ( event ) {
			event.preventDefault();
			event.stopPropagation();
			const href = $( this ).attr( 'href' );

			if ( ! $( this ).hasClass( 'disabled' ) ) {
				$( this )
					.closest( '.form-estim' )
					.find( '.form-estim__nav__item a[href=' + href + ']' )
					.removeClass( 'disabled' )
					.trigger( 'click' );
			}
		} );

		$( '#form-estim-consent' ).on( 'change', function () {
			if ( $( this ).prop( 'checked' ) ) {
				$( '.form-send' ).prop( 'disabled', false );
				$( '.form-estim__bottom__links a' ).removeClass( 'disabled' );
			} else {
				$( '.form-send' ).prop( 'disabled', true );
				$( '.form-estim__bottom__links a' ).addClass( 'disabled' );
			}
		} );

		$( '.form-estim__add a' ).on( 'click', function ( event ) {
			event.preventDefault();
			const href = $( this ).attr( 'href' );
			$( href ).removeClass( 'form-estim__items--hidden' );
			$( this ).hide();
		} );
	}
} )( jQuery );
